'use client';
import React from 'react';
import { useHandleSearch } from '@/hooks/useHandleSearch';
import { CpvCodeDto } from '@/actions/dtos/cpvCode';

interface CpvCodeButtonProps {
  code: CpvCodeDto;
}

const CpvCodeButton: React.FC<CpvCodeButtonProps> = ({ code }) => {
  const { handleSearch } = useHandleSearch();

  return (
    <div
      key={code.identifier}
      className="inline-block max-w-xs cursor-pointer truncate whitespace-nowrap rounded-full bg-base-100 px-4 py-2 text-sm hover:bg-primary hover:text-primary-content"
      title={code.name}
      style={{ maxWidth: '225px' }}
      onClick={() => handleSearch(code.name)}
    >
      {code.name}
    </div>
  );
};

export default CpvCodeButton;
